module.exports = __webpack_public_path__ + "img/operate7.80702bfb.png";